import React, {useState, useEffect} from "react";
import axios from "axios";
import renderHTML from "react-render-html";
import {updateObjectField} from '../helpers';

export default function ProductSearch(props) {
    let {onSelect} = props;
    let [model, setModel] = useState([]);
    let [filter, setFilter] = useState({});

    let updateFilterField = (field, value) => {
        setFilter(updateObjectField(filter, field, value));
    };

    let reloadProducts = async () => {
        let response = await axios('/admin/product/ajax-list/', {params: filter});
        setModel(response.data.data);
    };

    useEffect(() => {
        reloadProducts();
    }, [filter]);

    return <div>
        <div className="row">
            <div className="col-md-6">
                <div className="form-group">
                    <input type="text"
                           value={filter.articul || ''}
                           onChange={event => updateFilterField('articul', event.target.value)}
                           placeholder='Артикул'
                           className="form-control"
                    />
                </div>
            </div>
        </div>

        <table className="table table-striped">
            <tbody>
            {
                model.map((item) =>
                    <tr key={item.id}>
                        <td>
                            <img style={{maxWidth: '50px'}} src={item.image} alt=""/>
                        </td>
                        <td>
                            {item.articul}
                        </td>
                        <td>
                            {item.name}
                        </td>
                        <td>
                            {renderHTML(item.description)}
                        </td>
                        <td>
                            {item.productSizes.map((ps) =>
                                <span key={ps.id} style={{margin: 2}}
                                      onClick={() => onSelect(ps)}
                                      className={'label label-' + (ps.qty > 0 ? 'success' : 'danger')}>
                                            {ps.size.name} ({ps.qty})
                                        </span>
                            )}
                        </td>
                    </tr>
                )
            }
            </tbody>
        </table>
    </div>
}